module.exports = __webpack_public_path__ + "static/media/M1-32-Feitiço-Dracônico-cod151.bf7103ef.png";